exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.scroll-container[data-v-e9459c5e]{position:relative;width:100%;height:100%;background-color:#304156\n}\n.scroll-container .scroll-wrapper[data-v-e9459c5e]{position:absolute;width:100% !important\n}\n", "", {"version":3,"sources":["/var/jenkins_home/workspace/pro-maibenben-mall-admin-front/src/components/ScrollBar/index.vue"],"names":[],"mappings":";AACA,mCAAmC,kBAAkB,WAAW,YAAY,wBAAwB;CACnG;AACD,mDAAmD,kBAAkB,qBAAqB;CACzF","file":"index.vue","sourcesContent":["\n.scroll-container[data-v-e9459c5e]{position:relative;width:100%;height:100%;background-color:#304156\n}\n.scroll-container .scroll-wrapper[data-v-e9459c5e]{position:absolute;width:100% !important\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9459c5e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScrollBar/index.vue
// module id = S0uD
// module chunks = 65